<template>
  <div>
    <div class="menu" ref="menu">
      <Menu :bus="bus"/>
    </div>
    <div class="home fullpage" ref="fullpage">
      <div class="section" data-anchor="page">
        <Banner
          :bus="bus"
          class="home_banner_1 mainchild"
          :pageable="pageable"
          :afterscroller="require(`@/assets/img/citazioni_${$i18n.locale}.svg`)"
          v-bind:bgvideo="require(`@/assets/img/bannervideo.mp4`)"
        >
          <div class="container">
            <div class="col-md-10 mx-auto">
              <img class="max-width-100" src="@/assets/img/logo.svg">
              <Title v-bind:title="$t('home.title')" v-bind:main="true"></Title>
            </div>
          </div>
        </Banner>
      </div>
      <div class="section" data-anchor="page">
        <div class>
          <Hero
            :bus="bus"
            class="home_hero_1 mainchild"
            v-bind:title="$t('home.banner1.title')"
            v-bind:text="$t('home.banner1.text')"
            v-bind:bgimage="require(`@/assets/img/chi-siamo.jpg`)"
          ></Hero>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild"
              v-bind:title="$t('home.sec1.title')"
              v-bind:text="$t('home.sec1.text')"
              v-bind:images="[require(`@/assets/img/ricerca.jpg`)]"
            />
          </div>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild"
              v-bind:title="$t('home.sec2.title')"
              v-bind:text="$t('home.sec2.text')"
              v-bind:isInvert="true"
              v-bind:video="require(`@/assets/img/progettazione.mp4`)"
            />
          </div>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild home_sec3"
              v-bind:title="$t('home.sec3.title')"
              v-bind:text="$t('home.sec3.text')"
              v-bind:images="[require(`@/assets/img/realizzazione 1.gif`), require(`@/assets/img/realizzazione 2.gif`)]"
            />
          </div>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild"
              v-bind:title="$t('home.sec4.title')"
              v-bind:text="$t('home.sec4.text')"
              v-bind:isInvert="true"
              v-bind:bgvideo="require(`@/assets/img/produzione_background.mp4`)"
            />
          </div>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild home_sec6"
              v-bind:isInvert="true"
              v-bind:title="$t('home.sec6.title')"
              v-bind:text="$t('home.sec6.text')"
              :bgimage="require(`@/assets/img/Sostenibilita-background.jpg`)"
              v-bind:images="[require(`@/assets/img/sostenibilita-slide-1.jpg`), require(`@/assets/img/sostenibilita-slide-2.jpg`)]"
            >
              <div></div>
            </ImgText>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="black_sections">
          <div class="container">
            <ImgText
              :bus="bus"
              class="mainchild home_sec5"
              v-bind:text="$t('home.sec5.text')"
              v-bind:images="[require(`@/assets/img/Collaborazioni.jpg`), require(`@/assets/img/Collaborazioni-2.jpg`), require(`@/assets/img/parigi-1.jpg`), require(`@/assets/img/parigi-2.jpg`), require(`@/assets/img/parigi-3.jpg`)]"
            >
              <div>
                <a href="https://www.ifmparis.fr/en/" target="_blank" rel="noopener">
                  <img class="mt-4 d-flex mx-auto" src="@/assets/img/institut.png">
                </a>
              </div>
            </ImgText>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="page">
        <div class="footer mainchild">
          <div class="container">
            <div class="row">
              <div
                class="contact__container pt-5 pb-5 col-lg-5 d-flex flex-column justify-content-center"
              >
                <Title astitle="true" v-bind:title="$t('home.contact.title')"/>
              </div>
              <div class="form__container pt-5 pb-5 col-lg-7">
                <h1 v-html="$t('home.contact.form.title')"></h1>
                <MainForm class="d-flex text-center mt-5 justify-content-center footer__form"/>
                <div
                  class="mt-4 contact__container_div d-flex flex-column text-center justify-content-center"
                >
                  <div>
                    <div class="row contact__locations">
                      <div class="col-sm-4 d-flex flex-column text-center mt-4">
                        <p class="contact__locations_icon">
                          <a href="tel:00390599120411">
                            <img src="@/assets/img/phone.svg">
                          </a>
                        </p>
                        <p>
                          <a href="tel:00390599120411">+39 059.9120411</a>
                        </p>
                      </div>
                      <div class="col-sm-4 d-flex flex-column text-center mt-4">
                        <p class="contact__locations_icon">
                          <a href="mailto:info@weg.it">
                            <img src="@/assets/img/email.svg">
                          </a>
                        </p>
                        <p>
                          <a href="mailto:info@weg.it">info@weg.it</a>
                        </p>
                      </div>
                      <div class="col-sm-4 d-flex flex-column text-center mt-4">
                        <p class="contact__locations_icon">
                          <a href="https://goo.gl/maps/PZBH8VahViRK5sEa9">
                            <img src="@/assets/img/pin.svg">
                          </a>
                        </p>
                        <p>
                          <a href="https://goo.gl/maps/PZBH8VahViRK5sEa9">
                            Via Campania, 3
                            <br>41012 Carpi (Modena) Italy
                          </a>
                        </p>
                      </div>

                      <p
                        class="footer__copy"
                      >Weg srl - P.Iva e cod. Fisc. 02485070359 - Codice univoco: subm70n</p>
                      <div class="col-sm-12 mt-5 contact__member">
                        <p>
                          Member of
                          <a href="http://www.wegfashiongroup.com/" target="_blank" rel="noopener">
                            <img src="@/assets/img/wfg.png">
                          </a>
                        </p>
                      </div>
                    </div>

                    <p>
                      <a
                        :href="'//www.iubenda.com/privacy-policy/' + $t('iubendaid')"
                        target="_blank" rel="noopener"
                        class="iubenda-nostyle no-brand"
                        title="Privacy Policy"
                      >Privacy policy</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Banner from "@/components/Banner";
import Hero from "@/components/Hero";
import ImgText from "@/components/ImgText";
import Title from "@/components/Title";
import Menu from "@/components/Menuold";
import MainForm from "@/components/form/MainForm";

import fullpage from "fullpage.js";

export default {
  name: "home",
  data() {
    return {
      pageable: Function,
      currpageIdx: Number,
      currpageEl: HTMLElement,
      bus: new Vue()
    };
  },
  components: {
    Menu,
    Banner,
    Hero,
    ImgText,
    Title,
    MainForm
  },
  mounted() {

    this.$nextTick(() => {
      (function(w, d) {
        var loader = function() {
          var s = d.createElement("script"),
            tag = d.getElementsByTagName("script")[0];
          s.src = "//cdn.iubenda.com/iubenda.js";
          tag.parentNode.insertBefore(s, tag);
        };
        if (w.addEventListener) {
          w.addEventListener("load", loader, false);
        } else if (w.attachEvent) {
          w.attachEvent("onload", loader);
        } else {
          w.onload = loader;
        }
      })(window, document);

      {
        let id = 0;
        for (let el of this.$el.querySelectorAll('[data-anchor="page"]')) {
          el.setAttribute("data-anchor", "page" + id++);
        }
      }

      this.pageable = new fullpage(this.$refs.fullpage, {
        responsiveWidth: 576,
        responsiveHeight: 600,
        menu: ".menu",
        onLeave: (origin, destination, direction) => {
          this.bus.$emit("pagechanging", this.currpageEl, destination);
        },
        afterLoad: (origin, destination, direction) => {
          this.currpageIdx = destination.index;
          this.currpageEl = this.$refs.fullpage.children[
            this.currpageIdx
          ].querySelector(".mainchild");

          this.bus.$emit("pagechange", this.currpageEl);
        }
      });
    });
  }
};
</script>


<style lang="scss">
@import "pageable/src/pageable.scss";

.fp-responsive .fp-section,
.fp-responsive .fp-tableCell {
  height: auto !important;
}

.max-width-100 {
  max-width: 100%;
}
.fp-section .container {
  transition: opacity 0.1s
}
.fp-section:not(.active) .container {
  @include media-breakpoint-up(md) {
    opacity: 0 !important;
  }
}
.fp-section {

  @media (max-height: 599px) {
    &, .fp-tableCell, .fp-tableCell > div, .hero {
      min-height: 100vh;
    }
  }
}
</style>

<style scoped lang="scss">
.section {
  position: relative;
}
.home_banner_1,
.black_sections {
  background: black;
  color: white;
  /deep/ a {
    color: white;
    text-decoration: underline;
  }
}

.fp-tableCell,
.home_hero_1,
.home_hero_1 /deep/ .bg,
.home_banner_1 {
  @include media-breakpoint-down(sm) {
    min-height: 100vh;
  }
}

.home_hero_1 /deep/ .col-sm-6:first-child {
  flex: 100%;
  max-width: 100%;
  margin-bottom: 30px;
}
.home_hero_1 /deep/ .bg {
  background-size: cover;
}

.fp-tableCell > div > div > div {
  @include media-breakpoint-down(sm) {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }
}

.black_sections /deep/ p {
  color: white;
}
.black_sections /deep/ strong {
  color: white;
}

.fp-tableCell > div,
.pg-page > .banner,
.pg-page > .banner,
.pg-container > .section > div:not(.footer) {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.pg-page > .banner {
  justify-content: space-around;
}

.home_hero_1 /deep/ p {
  color: black;
}

.home_sec3 /deep/ .imgtext__box svg {
  width: 75%;
  height: 96%;
}
.home_sec6 /deep/ h3 {
  font-size: 21px;
}
.home_sec6 /deep/ p {
  color: black;
  font-size: 13px;
}
.home_sec6 /deep/ .title {
  color: black;
  text-shadow: none;
}
.home_sec6 /deep/ .imgtext__text {
  padding-top: 0;
}
.home_sec5 /deep/ .imgtext__text {
  padding-top: 30px;
}
.home_sec5 /deep/ .imgtext__text > div {
  display: flex;
  flex-direction: column;
  > div:last-child {
    order: 1;
    margin-bottom: 30px;
  }
  > p:first-child {
    order: 2;
  }
}

.footer {
  height: 100%;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    z-index: 0;
    background: $red url("~@/assets/img/Contatti.jpg") no-repeat center center /
      cover;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: none;
    @include media-breakpoint-up(lg) {
      width: 40%;
      display: block;
    }
    @media (max-height: 800px) {
      display: none !important;
    }
  }
  &:after {
    content: "";
    position: absolute;
    z-index: -1;
    background: black;
    width: 100%;
    height: 100%;
    right: 0;
    top: 0;
    width: 100%;
  }
  > div {
    position: relative;
    z-index: 2;
  }

  h1 {
    color: white;
  }
}
.contact__container {
  &,
  a {
    color: $white;
  }
  @media (max-height: 800px) {
    display: none !important; 
  }
}

.form__container {
  @media (max-height: 800px) {
    width: 100% !important;
    max-width: 100%;
    flex: 100% !important;
  }
}

.contact__container_div {
  a {
    color: white;
  }
}
.contact__member {
  color: white;
  text-align: center;
  img {
    margin-left: 10px;
    margin-top: -8px;
    vertical-align: middle;
  }
  @media(max-height: 900px) {
    margin-top: 10px;
  }
}
.contact__locations {
  margin-bottom: 20px;
  a {
    font-size: 14px;
    display: inline-block;
  }
  p {
    margin-bottom: 0;
  }
  @media(max-height: 900px) {
    margin-bottom: 5px;
  }
}
.contact__locations_icon {
  height: 48px;
  margin-bottom: 7px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media(max-height: 900px) {
    height: 44px;
  }
}
.form__container > h1 {
  @include media-breakpoint-down(sm) {
    font-size: 22px;
  }
}
.form__container /deep/ .mainform {
  @include media-breakpoint-up(md) {
    width: 100%;
  }
}
.footer__copy {
  color: #9c9e9f;
  font-size: 13px;
  margin-top: 40px;
  text-align: center;
  width: 100%;
  @media(max-height: 900px) {
    margin-top: 10px;
  }
}

.footer__form /deep/ {
  .message,
  textarea,
  a,
  input {
    color: white;
  }
  a {
    text-decoration: underline;
  }
  textarea,
  input:not([type="submit"]) {
    border-bottom-color: white;
  }
  input[type="checkbox"] {
    flex-shrink: 0;
  }
  textarea {
    height: 35px;
  }
  form {
    display: flex;
    flex-wrap: wrap;
  }
  @include media-breakpoint-up(sm) {
    .form-group:nth-last-child(-n + 2) {
      margin-bottom: 0;
    }
    form > div {
      width: calc(50% - 20px);
    }
    form > div:nth-child(odd) {
      margin-right: 20px;
    }
  }
}

.iubenda-nostyle {
  font-size: 13px;
}
</style>
